import { createContext, useContext, useState } from "react";

export interface StickyHeaderContext {
    isHeaderFixed: boolean;
    setIsHeaderFixed: (fixed: boolean) => void;
}

const defaultStickyHeaderContext: StickyHeaderContext = {
    isHeaderFixed: false,
    setIsHeaderFixed: (fixed: boolean) => {
        throw new Error('setIsHeaderFixed was called before being initialized by StickyHeaderProvider');
    }
}

export const StickyHeaderContext = createContext<StickyHeaderContext>(defaultStickyHeaderContext);

export const StickyHeaderProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isHeaderFixed, setIsHeaderFixed] = useState(false);
    return (
        <StickyHeaderContext.Provider value={{ isHeaderFixed, setIsHeaderFixed }}>
            {children}
        </StickyHeaderContext.Provider>
    )
}

export const useStickyHeaderContext = () => {
    return useContext(StickyHeaderContext);
}